import { Component } from '@angular/core';
import { ModalService } from '@lsq-frontend/common-ui';
import { FeeType, FeeTypeDisplayValue } from '../../models';

@Component({
    selector: 'save-fee-structure-modal',
    template: `
        <div class="modal-body">
            <p class="body" [style.marginBottom]="'2rem'">
                The fee structure settings for this supplier will be updated to the following:
            </p>
            <p class="label" [style.marginBottom]="'1rem'">
                {{ feeStructureUpdateData.supplierName }}
            </p>
            <data-card [style.marginBottom]="'2rem'" [style.display]="'block'">
                <p class="label fee-type-header">
                    {{ feeTypeDisplayValue[feeStructureUpdateData.feeType] }}
                </p>
                <p>
                    {{ feeStructureUpdateData.feePercent }}
                </p>
            </data-card>
            <data-card [style.display]="'block'">
                <p class="label">
                    Ineligible Days Before Terms
                </p>
                <p *ngIf="feeStructureUpdateData.daysBeforeTerms">
                    {{ feeStructureUpdateData.daysBeforeTerms | days: true }}
                </p>
                <p *ngIf="!feeStructureUpdateData.daysBeforeTerms">—</p>
            </data-card>
        </div>
    `
})
export class SaveFeeStructureModalComponent {
    public feeStructureUpdateData: {
        supplierName: string;
        feeType: FeeType;
        feePercent?: number;
        daysBeforeTerms?: number;
    };
    public feeTypeDisplayValue = FeeTypeDisplayValue;

    constructor(private _modalService: ModalService) {
        this.feeStructureUpdateData = this._modalService.modal.data;
    }
}
